<template>
    <div :class="className">
        <div class="o-select__inner">
            <span class="o-select__box" @click.stop="isFocused = !isFocused">
                <span class="o-select__placeholder">
                    {{ option ? option[oKey] : placeholder }}
                </span>
                <span class="o-select__arrow">
                    <icon icon="arrow-stroke-down" />
                </span>
            </span>
            <ul class="o-select__list">
                <li v-for="(o, i) in options" :key="`option-${i}`" class="o-select__option">
                    <button
                        type="button"
                        class="o-select__text"
                        :class="{ 'is-active': activeIndex === i }"
                        @click="updateOption(o, i)"
                    >
                        {{ o[oKey] }}

                        <span v-if="activeIndex === i" class="o-select__cross" />
                    </button>
                </li>
            </ul>
        </div>
        <app-input-text v-if="showInput" v-model="inputVal" />
        <input type="text" :value="value" hidden />
    </div>
</template>

<script>
import Icon from "objects/Icon";
import AppInputText from "objects/AppInputText";

export default {
    name: "AppSelect",
    components: {
        Icon,
        AppInputText
    },
    props: {
        placeholder: {
            type: String,
            default: "Placeholder"
        },
        options: {
            type: Array,
            default: () => ({})
        },
        as: String
    },
    data: () => ({
        value: "",
        inputVal: false,
        option: false,
        isFocused: false,
        isFilled: false,
        activeIndex: -1
    }),
    computed: {
        className() {
            let className = "o-select";

            if (this.disabled) {
                className += " is-disabled";
            }
            if (this.isFilled) {
                className += " is-filled";
            }
            if (this.isFocused) {
                className += " is-focused";
            }

            return className;
        },
        asKeyValue() {
            return this.as.split(":");
        },
        oKey() {
            return this.asKeyValue[0];
        },
        oValue() {
            return this.asKeyValue[1];
        },
        showInput() {
            return ["autre", "other"].includes(this.value.toLowerCase());
        }
    },
    created() {
        window.addEventListener(
            "click",
            (this.clickEvent = () => {
                this.isFocused = false;
            })
        );
    },
    methods: {
        updateOption(option, index = -1) {
            if (this.activeIndex === index) {
                this.option = false;
                this.activeIndex = -1;
            } else {
                this.option = option;
                this.activeIndex = index;
            }
        },
        setOption(value) {
            // const vm = this;

            // Find option index
            const optionIndex = this.options.findIndex(option => option[this.oValue] === value);

            // Update option with value if exists
            if (optionIndex > -1) {
                this.updateOption(this.options[optionIndex], optionIndex);
            }
        }
    },
    watch: {
        option(option) {
            if (!this.showInput) {
                this.value = option === false ? "" : option[this.oValue];
            }
            this.isFilled = this.value !== "";
            this.isFocused = false;
            this.$emit("input", this.value);
        },
        inputVal(val) {
            let value = this.showInput ? this.value + `: ${val}` : this.value;
            this.$emit("input", value);
        }
    },
    destroyed() {
        window.removeEventListener("click", this.clickEvent);
    }
};
</script>

<style lang="scss">
.o-select {
    --height: 2em;
    --c-bg: #{$color-light};
    --c-text: #{$color-dark};

    --border: 1px solid #{$color-grey};

    .o-input-text {
        margin-top: 0.5rem;
    }

    &.is-focused {
        z-index: 1;

        .o-select__arrow {
            .o-icon {
                transform: rotate(180deg);
            }
        }

        .o-select__list {
            z-index: 10;
            display: block;
        }
    }
}

.o-select__inner {
    min-width: 10em;
    border-bottom: var(--border);
}

.o-select__box {
    display: flex;
    align-items: center;
    height: var(--height);
    padding-right: var(--height);
    color: var(--c-text);
    background-color: var(--c-bg);
    user-select: none;
    cursor: pointer;
}

.o-select__placeholder {
    display: block;
    flex-grow: 1;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.o-select__arrow {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: var(--height);
    height: 100%;
    cursor: pointer;

    svg {
        width: 0.75em;
        height: 0.75em;
    }
}

.o-select__list {
    position: absolute;
    top: 100%;
    right: -0.5rem;
    left: -0.5rem;
    width: auto;
    max-height: 12em;
    @include reset-list;
    background-color: var(--c-bg);
    overflow-y: auto;

    display: none;
}

.o-select__option {
}

.o-select__text {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 0.75em 0.5rem;
    text-align: left;
    cursor: pointer;
    white-space: nowrap;
    border-bottom: var(--border);
    transition: background-color 0.2s ease-out;

    &:hover {
        color: $color-grey;
    }

    &.is-active {
        font-weight: 700;

        &:hover {
            .o-icon {
                transform: scale(1.2);
            }
        }
    }

    .o-icon {
        font-size: 0.5rem;
        transition: transform 0.2s ease-out;
    }
}

.o-select__cross {
    display: block;
    width: 0.75em;
    height: 0.75em;

    &:after,
    &:before {
        @include pseudo-el($height: 1px, $bg: currentColor);
        position: absolute;
        top: 50%;
        left: 0;
    }

    &:before {
        transform: rotate(-45deg);
    }

    &:after {
        transform: rotate(45deg);
    }
}
</style>
